import React from 'react';
import { ReviewsModel } from '../models/ReviewsModel';

interface ReviewsState {
    currentIndex: number;
}

interface ReviewsProps {
    content: ReviewsModel[];
}

class Reviews extends React.Component<ReviewsProps, ReviewsState> {
    get hasNext():boolean {
        return !(this.state.currentIndex >= (this.props.content.length-1));
    }

    get hasPrev():boolean {
        return !(this.state.currentIndex <= 0);
    }

    get leftPos():number {
        return this.state.currentIndex * 100 * -1;
    }

    constructor(props:ReviewsProps) {
        super(props);

        this.state = {
            currentIndex: 0
        }
    }


    prev() {
        if(!this.hasPrev) return;
        const currentIndex = this.state.currentIndex-1;
        this.setState({currentIndex});

    }

    next() {
        if(!this.hasNext) return;
        const currentIndex = this.state.currentIndex+1;
        this.setState({currentIndex});
    }
    
    render() {
        const { content } = this.props;

        return (
            <div className="reviews__inner">
                <div className="reviews__items" style={{transform:`translateX(${this.leftPos}%)`}}>
                    {
                        content.map((review, index) => {
                            return (
                                <div key={`reviewItem${index}`} className={`reviews__item ${index === this.state.currentIndex ? 'reviews__item--current' : ''}`}>
                                    <div className="reviews__quote">
                                        {review.quote}
                                    </div>

                                    <div className="reviews__author">
                                        {review.author}
                                    </div>
                                    {
                                        (typeof review.authorUrl != 'undefined' && review.authorUrl) ?
                                            <div>
                                            <a href={review.authorUrl} target="_blank" className="btn btn--text">Read full review</a>
                                            </div>
                                        : null
                                    }
                                   
                                </div>
                            );
                        })
                    }
                </div>
                {
                    this.hasNext || this.hasPrev ?
                        <div className="reviews__controls">
                            <div className={`reviews__control reviews__control--prev ${!this.hasPrev ? 'reviews__control--disabled' : ''}`} onClick={() => this.prev()}>&lt;</div>
                            <div className={`reviews__control reviews__control--next ${!this.hasNext ? 'reviews__control--disabled' : ''}`} onClick={() => this.next()}>&gt;</div>
                        </div>
                    : null
                }
            </div>
        )
    }
}

export default Reviews;